import { useEffect, useState } from "react";
import { Navbar } from "../components/Navbar";
import { AccountSettings } from "../components/Settings/Account";
import { DangerSettings } from "../components/Settings/Danger";
import { NotificationsSettings } from "../components/Settings/Notifications";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const Settings = () => {
  const { currentUser, updateProfile, logout, deleteAccount, isAuthenticated } =
    useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [showConfirmCard, setShowConfrimCard] = useState(false);
  const [confirmText, setConfirmText] = useState("");

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
      return;
    }
    if (currentUser?.email) {
      setEmail(currentUser.email);
    }
  }, [currentUser, isAuthenticated, navigate]);

  const handleSaveEmail = async (e) => {
    e.preventDefault();
    setSaving(true);
    const res = await updateProfile({ email });
    setSaving(false);
    if (res.success) {
      alert("✅ Email updated successfully");
    } else {
      alert("❌ " + res.error);
    }
  };

  const handleDeleteAccount = async () => {
    if (confirmText !== "Confirm") {
      alert("❌ You must type 'Confirm' exactly to delete your account.");
      return;
    }

    setDeleting(true);
    try {
      const response = await deleteAccount();

      if (response.success) {
        alert("✅ Account deleted");
        setDeleting(false);
        logout();
        navigate("/");
      } else {
        alert("❌ " + response.message);
      }
    } catch (error) {
      setDeleting(false);
      console.error("Delete error:", error);
      alert("❌ Something went wrong");
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <main className="flex-1 pt-24 pb-16">
        <div className="container px-4 mx-auto">
          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold mb-2">Settings</h1>
            <p className="text-muted-foreground">
              Manage your account preferences and privacy settings
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {/* Account details */}
            <AccountSettings
              email={email}
              setEmail={setEmail}
              saving={saving}
              handleSaveEmail={handleSaveEmail}
            />

            <div className="space-y-6">
              {/* Notification */}
              <NotificationsSettings />

              {/* Danger */}
              <DangerSettings
                showConfirmCard={showConfirmCard}
                setShowConfirmCard={setShowConfrimCard}
                deleting={deleting}
                handleDeleteAccount={handleDeleteAccount}
                confirmText={confirmText}
                setConfirmText={setConfirmText}
              />
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-igbanwo-mint/5 p-8 border-t border-border/60">
        <div className="container px-4 mx-auto text-center text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} Thoreau Consulting (PTY) Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Settings;
